import React, { useEffect, useState } from "react";
import styles from "./ProductCategories.module.scss";
import classNames from "classnames/bind";
import ProductItem from "../../components/ProductItem/ProductItem";
// import { getCategories } from "../../services/Products/ProductServices";
import { Link } from "react-router-dom";
import useTranslations from "../../hooks/useTranslations";

const cx = classNames.bind(styles);

const ProductCategories = ({ items = [], showTittle = false }) => {
  const [category, setCategory] = useState(items);
  const currentTranslations = useTranslations()
  useEffect(() => {
    setCategory(items);
  }, [items]);
  
  return (
    <div className={cx("container-category")}>
      {showTittle && (
        <Link to={`/products/category`} className={cx("category-title")}>
          {currentTranslations?.orther?.Shop_by_category}
        </Link>
      )}
      <div className={cx("category-items")}>
        {Array.isArray(category) &&
          category
            // .filter(item => item.slug !== "chua-phan-loai")
            .map((item) => (
              <ProductItem
                key={item.id}
                srcImage={item.image?.src}
                productText={item.name}
                textType="title"
                href={item.href}
                isShowHeart={false}
              />
            ))}
      </div>
    </div>
  );
};

export default ProductCategories;
